export const Radio = ({ isCheck }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9.5" fill="white" stroke={isCheck ? "#E96C12" : "#E1E1E1"} />
        <circle cx="10.0003" cy="9.99996" r="5.83333" fill={isCheck ? "#E96C12" : "#FFFFFF"} />
    </svg>
);
